// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_ddfZ2","body":"body_E29eg","case":"case_2RpAw","title":"title_zQy5n","place":"place_RBZeR","desc":"desc_RNZef"};